import styled from "styled-components";
import { radius } from "@libertify/ui";

export const AuthInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  height: 44px;
  padding: 10px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 16px;
  background: white;
  color: #111827;
  outline: none;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    border-color: #14b8a6;
    box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.1);
  }
`;

export const AuthSubmitButton = styled.button`
  width: 100%;
  height: 44px;
  background: #14b8a6;
  border: none;
  border-radius: ${radius.pill}px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: #0d9488;
  }
`;

export const AuthLink = styled.a`
  color: #14b8a6;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;

  &:visited,
  &:hover,
  &:active {
    color: #14b8a6;
  }

  &:hover {
    text-decoration: underline;
  }
`;

export const AuthLegalText = styled.p`
  text-align: center;
  font-size: 11px;
  color: #9ca3af;
  margin: 0;
  line-height: 1.5;
`;

export const AuthBottomLine = styled.p`
  text-align: center;
  font-size: 14px;
  color: #374151;
  margin: 0;
`;

export const PasswordReveal = styled.div<{ $visible: boolean }>`
  display: grid;
  grid-template-rows: ${(p) => (p.$visible ? "1fr" : "0fr")};
  opacity: ${(p) => (p.$visible ? 1 : 0)};
  margin-top: ${(p) => (p.$visible ? "0px" : "-12px")};
  transition:
    grid-template-rows 0.3s ease,
    opacity 0.3s ease,
    margin-top 0.3s ease;
  overflow: hidden;
  width: 100%;

  > div {
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;

// Wraps antd's Input.OTP with the auth pages' visual language — its cells
// aren't reachable via props, only via the `.ant-otp`/`.ant-otp-input` classes.
export const AuthOtpInput = styled.div`
  width: 100%;

  .ant-otp {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 8px;
  }

  .ant-otp-input {
    flex: 1;
    height: 56px;
    font-size: 24px;
    font-weight: 600;
    font-family: "Inter Variable", sans-serif;
    border-radius: 8px;
    border-color: #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: center;
    transition:
      border-color 0.15s,
      box-shadow 0.15s;

    &:focus {
      border-color: #14b8a6;
      box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.1);
    }
  }
`;

export const AuthSecurityNote = styled.p`
  text-align: center;
  font-size: 11px;
  color: #9ca3af;
  margin: 12px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;
